import { handleActions } from 'redux-actions'
import * as type from './type'


export const initialState = {
    appointment: {},
    fetching: false,
    error: null,
}


export default handleActions({

    [type.FIND_APPOINTMENT_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.FIND_APPOINTMENT_SUCCESS]: (state, action) => {
        const { appointment } = action.payload
        return {
            ...state,
            appointment,
            fetching: false,
        }
    },
    [type.FIND_APPOINTMENT_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.CHANGE_APPOINTMENT]: (state, action) => {
        const { name, value } = action.payload
        return {
            ...state,
            appointment: {
                ...state.appointment,
                [name]: value,
            },
        }
    },
    [type.SET_APPOINTMENT_CANCEL_CATEGORY_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.SET_APPOINTMENT_CANCEL_CATEGORY_SUCCESS]: (state, action) => {
        const { appointment } = action.payload
        return {
            ...state,
            appointment,
            fetching: false,
        }
    },
    [type.SET_APPOINTMENT_CANCEL_CATEGORY_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },

}, initialState)



// WEBPACK FOOTER //
// ./src/modules/appointment/state/detail/reducer.js